import { onLCP, onCLS, onINP } from 'web-vitals';
import { trackEvent } from '@/lib/analytics';
import { redactPrivatePaths } from '@/lib/private-paths';
import { isNative } from '@/lib/capacitor';

// Field Core Web Vitals → GA4 (docs/roadmap/0155 C5, #124). Reports the three
// CWV metrics with the landing page path, so organic landing pages can be
// segmented in GA4 (the SSR + font-preload work is otherwise unmeasured).
// Web only: native WebView numbers aren't comparable to browser field data.
//
// GA4 conventions: one `web_vitals` event per final metric value; CLS is
// multiplied by 1000 (GA4 metrics are integers); `metric_id` lets a session's
// duplicate reports be deduped in BigQuery/explorations.
function report({ name, value, rating, id }) {
  trackEvent('web_vitals', {
    metric_name: name,
    metric_value: Math.round(name === 'CLS' ? value * 1000 : value),
    metric_rating: rating,
    metric_id: id,
    // A custom parameter, so stripQuery never sees it: shared-chat and
    // unsubscribe tokens and friends' handles are redacted here (#521).
    page_path: redactPrivatePaths(window.location.pathname),
  });
}

export default function initWebVitals() {
  if (isNative()) return;

  onLCP(report);
  onCLS(report);
  onINP(report);
}
